import { mapActions, mapState } from 'vuex';
import ApiActions from '@/modules/api-actions';
import { EVENTS as HW_EVENTS } from '@/events/hardware';
import { parseActionFromText, parseStoreScan } from '@/modules/qr-action';

const handleQrScan = {
  mounted() {
    this.$events.on(HW_EVENTS.QRCODE_SUCCESS, this.onQrCodeSuccess);
    this.$events.on(HW_EVENTS.QRCODE_ERROR, this.onQrCodeError);
  },
  beforeDestroy() {
    this.$events.off(HW_EVENTS.QRCODE_SUCCESS, this.onQrCodeSuccess);
    this.$events.off(HW_EVENTS.QRCODE_ERROR, this.onQrCodeError);
  },
  data: () => ({
    qrCodeInvalid: false,
  }),
  methods: {
    ...mapActions('app', ['displayGarment', 'launchQrScan', 'cancelQrScan']),
    async onQrCodeSuccess(result) {
      console.log('onQrCodeSuccess result', result);
      const action = parseActionFromText(result);
      // a store QR with no qr_token is as dead as an unparseable one. Judge it
      // before closing the camera: the open overlay is what shows the error card
      if (!action.type || (action.type === 'store' && !parseStoreScan(action.payload))) {
        // keep the overlay open, that's what makes the error card visible
        this.qrCodeInvalid = true;
        return;
      }
      this.cancelQrScan();
      await this.handleIncomingAction(action);
    },
    onQrCodeError(error) {
      console.log('onQrCodeError', error);
    },
    async handleIncomingAction({ type, payload }) {
      console.log('handleIncomingAction', type, payload);
      if (type === 'garment') {
        this.displayGarment(payload);
      } else if (type === 'remote_signin' && payload) {
        this.$events.startLoading();
        try {
          await ApiActions.user.remoteSignIn(payload);
        } catch (e) {
          console.log(e.message);
        } finally {
          this.$events.stopLoading();
        }
      } else if (type === 'store' && payload) {
        this.goToMobileScan(payload);
      }
    },
    async handleDeepLink(link) {
      console.log('Got deep link', link);
      await this.handleIncomingAction(parseActionFromText(link));
    },
    goToMobileScan(payload) {
      // also the deep link path, where there is no camera overlay to warn in
      const scan = parseStoreScan(payload);
      if (!scan) {
        console.log('invalid store payload', payload);
        return;
      }
      // Discovery is behind the auth guard, so scanning before signing in
      // cannot get anywhere. Ignore it instead of letting the guard rewrite
      // the Login redirect query with nothing visible happening.
      if (!ApiActions.isAuthenticated()) {
        console.log('not signed in, ignoring store QR code');
        return;
      }
      // params only, so neither the store id nor the QR token lands in the URL
      // or survives a reload
      this.$events.goto('Discovery', { params: scan });
    },
  },
  computed: {
    ...mapState('app', ['isScanningQr']),
  },
  watch: {
    isScanningQr(open) {
      if (open) this.qrCodeInvalid = false;
    },
  },
};

export default handleQrScan;
